import { SafeLocalStorageService } from "@fidget/common/services/safeLocalStorageService";
import { staticConfig } from "@fidget/common/config/static-config";
import { detect } from "detect-browser";

export interface InitialContext {
  browserFamily: string;
  browserTimezone: string;
  browserLanguage: string;
}

export class InitialContextService {
  private readonly safeLocalStorage = SafeLocalStorageService.getInstance();
  private localStorageKey = staticConfig.localStorageKeyPrefix + "signUpContext";

  setSignUpContext(context: InitialContext) {
    this.safeLocalStorage.setItem(this.localStorageKey, JSON.stringify(context));
  }

  getSignUpContext(): Promise<InitialContext> {
    const savedSignUpContextJSON = this.safeLocalStorage.getItem(this.localStorageKey);
    this.safeLocalStorage.removeItem(this.localStorageKey);
    let savedSignUpContext: any;
    if (savedSignUpContextJSON) {
      try {
        savedSignUpContext = JSON.parse(savedSignUpContextJSON);
      } catch (_) {
        savedSignUpContext = {};
      }
    }

    const browser = detect();

    return Promise.resolve({
      browserFamily: browser?.name.toLowerCase(),
      browserTimezone: new Date().getTimezoneOffset(),
      browserLanguage: navigator.language.toLowerCase(),
      ...savedSignUpContext
    });
  }
}
